import { render, staticRenderFns } from "./abuse_category_selector.vue?vue&type=template&id=81455e9c"
import script from "./abuse_category_selector.vue?vue&type=script&lang=js"
export * from "./abuse_category_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports